// @generated by TypeGen from LogbookApi/DepthWatchApi - DO NOT EDIT

import type { IDepthWatchRequest } from "../LogbookApp/DepthWatchApi"
import type { IAppResponse } from "../LogbookApp/Routes"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface DepthWatchApiEndpoints {
  "PUT /api/ship/depth/watch": {
    params: {};
    query: {};
    request: IDepthWatchRequest;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const depthWatchApiEndpoints = {
  "PUT /api/ship/depth/watch": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
} as const;

export class DepthWatchApi {
  constructor(private client: ApiClient) {}

  depthWatch = {
    update: (a: ApiArgs<DepthWatchApiEndpoints, "PUT /api/ship/depth/watch">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ship/depth/watch", depthWatchApiEndpoints["PUT /api/ship/depth/watch"].targets);
        return this.client.call<IAppResponse>("PUT /api/ship/depth/watch", a);
      },
      url: (): string => this.client.url("PUT /api/ship/depth/watch", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
  };
}
